import React from "react"
import PropTypes from "prop-types"
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';


const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: '3.18rem',
    minWidth: '15rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '3.18rem',
    padding: '0 6px'
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '3.18rem',
  }),
}

class Rule extends React.Component {
  state = {
    editing: this.props.rule.editing,
    validated: false,
  }

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 10000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkLowerboundValidity = (form) => {
    const dyno_lower_bound = form.querySelector(".dyno-lower-bound");
    if (parseInt(this.props.rule.dyno_lower_bound) > parseInt(this.props.rule.dyno_upper_bound)){
      dyno_lower_bound.setCustomValidity("Dyno lower bound must be less than upper bound");
    } else {
      dyno_lower_bound.setCustomValidity("");
    }

    dyno_lower_bound.reportValidity();
    this.setState({
        validated: true
    })
  }

  checkUpperboundValidity = (form) => {
    const dyno_lower_bound = form.querySelector(".dyno-upper-bound");
    if (parseInt(this.props.rule.dyno_upper_bound) > parseInt(this.props.options.plan.max_dyno_count)){
      dyno_lower_bound.setCustomValidity("Dyno upper bound must be less or equal to the plan limit of " + this.props.options.plan.max_dyno_count + " dynos");
    } else {
      dyno_lower_bound.setCustomValidity("");
    }

    dyno_lower_bound.reportValidity();
    this.setState({
        validated: true
    })
  }

  checkQueuePresence = (form) => {
    const queues = form.querySelector("input[name='queues']");
    const queue_picker = form.querySelector(".select__input");
    
    if (queues.value === ''){
      queue_picker.setCustomValidity("At least 1 queue must be selected");
    } else {
      queue_picker.setCustomValidity("");
    }

    queue_picker.reportValidity();
    this.setState({
        validated: true
    })
  }

  checkMinUpscaleEllapsedValidity = (form) => {
    const upscale_ellapsed = form.querySelector(".upscale_ellapsed");
    if (parseInt(this.props.rule.upscale_ellapsed) < upscale_ellapsed.min){
      upscale_ellapsed.setCustomValidity("Ellapsed time between scaling events must be more than " + upscale_ellapsed.min + "s");
    } else {
      upscale_ellapsed.setCustomValidity("");
    }
    upscale_ellapsed.reportValidity();
    this.setState({
        validated: true
    })
  }

  checkMinDownscaleEllapsedValidity = (form) => {
    const downscale_ellapsed = form.querySelector(".downscale_ellapsed");
    if (parseInt(this.props.rule.downscale_ellapsed) < downscale_ellapsed.min){
      downscale_ellapsed.setCustomValidity("Ellapsed time between scaling events must be more than " + downscale_ellapsed.min + "s");
    } else {
      downscale_ellapsed.setCustomValidity("");
    }
    downscale_ellapsed.reportValidity();
    this.setState({
        validated: true
    })
  }

  checkTimeRangeValidity = (form) => {
    const time_start_at = form.querySelector(".time_start_at");
    const time_end_at   = form.querySelector(".time_end_at");
    var date_start_at = new Date();
    var time_parts = time_start_at.value.split(":");
    date_start_at.setHours(time_parts[0]);
    date_start_at.setMinutes(time_parts[1]);
    date_start_at.setSeconds(typeof time_parts[2] == 'undefined' ? "00" : time_parts[2]);
    var date_end_at = new Date();
    time_parts = time_end_at.value.split(":");
    date_end_at.setHours(time_parts[0]);
    date_end_at.setMinutes(time_parts[1]);
    date_end_at.setSeconds(typeof time_parts[2] == 'undefined' ? "00" : time_parts[2]);


    if (time_start_at.value  == "00:00:00" && time_end_at.value  == "00:00:00"){
      time_start_at.setCustomValidity("Active rule duration must be at least 1 minute.\n To set a full day, start time should be 12:00:00 AM (00:00:00)\n and end time should be 11:59:59 PM (23:59:59).");
    } else if (Math.abs(date_start_at - date_end_at) < 60000 ){
      time_start_at.setCustomValidity("Active rule duration must be at least 1 minute.");
    } else {
      time_start_at.setCustomValidity("");
    }

    time_start_at.reportValidity();
    this.setState({
        validated: true
    })
  }


  onSaveClick = (event) => {
    const form = event.currentTarget.closest("form")

    this.checkLowerboundValidity(form);
    this.checkUpperboundValidity(form);
    this.checkMinUpscaleEllapsedValidity(form);
    this.checkMinDownscaleEllapsedValidity(form);
    if (this.props.type == "Worker"){
      this.checkQueuePresence(form);
    }
    if (!this.props.rule.default_rule){
      this.checkTimeRangeValidity(form);
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        validated: true
      })
    } else {
      this.props.saveRule(this.props.rule)
      this.setState({
        editing: false
      })
    }
  }

  onDeleteClick = (event) => {
    this.props.deleteRule(this.props.rule);
  }

  onEditClick = (event) => {
    this.setState({
      editing: true,
    })
    this.props.setRuleUndoMark(this.props.rule.id);
  }

  onCancelClick = (event) => {
    if (this.props.rule.remote_id > 0){
      this.setState({
        editing: false,
        rule: null
      });
    } else {
      this.props.deleteRule(this.props.rule);
    }
    this.props.rollbackToLastUndoMark(this.props.rule.id);
  }

  onUpdateRuleChange = (event) => {
    var field = event.target.dataset.field;
    const form = event.currentTarget.closest("form");
    if (field == ""){
      this.checkLowerboundValidity(form);
      this.checkUpperboundValidity(form);
      this.checkMinUpscaleEllapsedValidity(form);
      this.checkMinDownscaleEllapsedValidity(form);
    }
    this.props.updateRule(this.props.rule.id, field, event.target.value);
  }

  onUpdateRuleQueueChange = (queues) => {
    const form = event.currentTarget.closest("form");
    
    var queue_names = queues.map((queue_selections, index) => {
      return queue_selections['value'];
    });
    this.props.updateRule(this.props.rule.id, 'queues', queue_names);
  }

  onReorderUpClick = (event) => {
    this.props.reorderUp(this.props.rule);
  }

  onReorderDownClick = (event) => {
    this.props.reorderDown(this.props.rule);
  }

  formatSelectedQueues = () => {
    var queues = this.props.rule.queues || [];
    return queues.map((queue, index) => {
      return { label: queue, value: queue};
    })
  }

  render () {
    var not_editing = (
      <React.Fragment>
        <div className={`rule ${this.props.activeRuleId() == this.props.rule.id ? 'active' : ''}`}>
        <div className="row pt-3 pb-2">
          <div className="col-md-6 col-lg-3">
            <div className="form-tooltip">
              <span className="fw-bolder">Dynos <FeatherIcon icon="help-circle" className="mt-1"/></span>
              <span className="form-tooltiptext">What is the upper and lower range of dynos that auto scale for this rule?</span>
            </div>
            <div className="mt-2 mb-4">
              {this.props.rule.dyno_lower_bound} - {this.props.rule.dyno_upper_bound}
            </div>
          </div>
          <div className={`col-md-6 col-lg-2 ${this.props.rule.default_rule ? 'd-none' : ''}`}>
            <div className="form-tooltip">
              <span className="fw-bolder">Day of Week  <FeatherIcon icon="help-circle" className="mt-1"/></span>
              <span className="form-tooltiptext">What day of the week should this rule apply to?</span>
            </div>
            <div className="mt-2 mb-4">
              {this.props.rule.dow}
            </div>
          </div>
          <div className={`col-md-6 col-lg-2 ${this.props.rule.default_rule ? 'd-none' : ''}`}>
            <div className="form-tooltip">
              <span className="fw-bolder">Start At  <FeatherIcon icon="help-circle" className="mt-1"/></span>
              <span className="form-tooltiptext">{`What hour should this rule start on in ${Intl.DateTimeFormat().resolvedOptions().timeZone} timezone?`}</span>
            </div>
            <div className="mt-2 mb-4">
              {new Date(`Aug 9, 1995 ${this.props.rule.time_start_at}`).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit', timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone})}
            </div>
          </div>
          <div className={`col-md-6 col-lg-2 ${this.props.rule.default_rule ? 'd-none' : ''}`}>
            <div className="form-tooltip">
              <span className="fw-bolder">End At  <FeatherIcon icon="help-circle" className="mt-1"/></span>
              <span className="form-tooltiptext">{`What hour should this rule end on in ${Intl.DateTimeFormat().resolvedOptions().timeZone} timezone?`}</span>
            </div>
            <div className="mt-2 mb-4">
              {new Date(`Aug 9, 1995 ${this.props.rule.time_end_at}`).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit', timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone})}
            </div>
          </div>
          <div className={`col-md-6 col-lg-6 ${this.props.rule.default_rule ? '' : 'd-none'}`}></div>
          <div className="d-none d-md-none d-lg-block col-md-12 col-lg-3">
            <div className="mb-3 mt-3 action-control">
              <div className="mr-1">
                <button className="btn btn-blue btn-icon btn-lg edit-rule" type="button" data-toggle="tooltip" data-placement="top" title="Edit rule" onClick={this.onEditClick} >
                 <FeatherIcon icon="edit"/>
                </button>
              </div>
              <div className={`mr-1 ${this.props.rule.default_rule ? 'invisible' : ''}`}>
                <button className="btn btn-red btn-icon btn-lg delete-rule" type="button" data-toggle="tooltip" data-placement="top" title="Delete rule" onClick={this.onDeleteClick} >
                 <FeatherIcon icon="delete"/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={`row ${this.props.type == "Worker" ? '' : 'd-none'}`}>
          <div className="col-md-6 col-lg-6">
            <div className="mb-3">
              <label>
                <div className="form-tooltip">
                  <span className="fw-bolder">Queues  <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">{`What queues are included in this rule when determining to auto scale?`}</span>
                </div>
              </label>
              <div className="mt-2 mb-4">
                {(this.props.rule.queues && this.props.rule.queues.length == 0) ? "No Queues" : (this.props.rule.queues || []).join(", ")}
              </div>
            </div>
          </div>
        </div>        
        <div className="row">
          <div className="col-md-12 col-lg-9">
            <div className="form-tooltip">
              <span className="fw-bolder">Upscale Configuration  <FeatherIcon icon="help-circle" className="mt-1"/></span>
              <span className="form-tooltiptext">Configuration information for upscaling</span>
            </div>
            <div className="mt-2 mb-4">
              When request queuing hits <strong>{this.props.rule.upscale_threshold} ms</strong>, upscale by <strong>{this.props.rule.upscale_increment} dyno(s)</strong> with <strong>{this.props.rule.upscale_ellapsed} s</strong> delay between upscales.
            </div>
          </div>
          <div className={`d-none d-sm-none d-md-none d-lg-block col-md-12 col-lg-3 ${this.props.rule.default_rule ? 'invisible' : ''}`}>
            <div className="mb-3 mt-3 action-control">
              <div className="mr-1">
                <button disabled={this.props.index == 0 || this.props.prev_rule.remote_id < 0} className="btn btn-black btn-icon btn-lg" type="button" data-toggle="tooltip" data-placement="top" title="Reorder Rule Up" onClick={this.onReorderUpClick} >
                 <FeatherIcon icon="chevron-up"/>
                </button>
              </div>
              <div className="mr-1">
                <button disabled={this.props.index == this.props.rule_count - 2} className="btn btn-black btn-icon btn-lg" type="button" data-toggle="tooltip" data-placement="top" title="Reorder Rule Down" onClick={this.onReorderDownClick} >
                 <FeatherIcon icon="chevron-down"/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row" className="row">
          <div className="col-md-12 col-lg-9">
            <div className="form-tooltip">
              <span className="fw-bolder">Downscale Configuration <FeatherIcon icon="help-circle" className="mt-1"/></span>
              <span className="form-tooltiptext">Configuration information for downscaling</span>
            </div>
            <div className="mt-2 mb-4">
              When request queuing hits <strong>{this.props.rule.downscale_threshold} ms</strong>, downscale by <strong>{this.props.rule.downscale_increment} dyno(s)</strong> with <strong>{this.props.rule.downscale_ellapsed} s</strong> delay between downscales.
            </div>
          </div>
          <div className="d-lg-none d-md-block col-md-12 col-lg-3">
            <div className="mb-3 mt-3 action-control">
              <div className={`mr-1 ${this.props.rule.default_rule ? 'invisible' : ''}`}>
                <button disabled={this.props.index == 0 || this.props.prev_rule.id < 0} className="btn btn-black btn-icon btn-lg mb-1" type="button" data-toggle="tooltip" data-placement="top" title="Reorder Rule Up" onClick={this.onReorderUpClick} >
                 <FeatherIcon icon="chevron-up"/>
                </button>
              </div>
              <div className={`mr-1 ${this.props.rule.default_rule ? 'invisible' : ''}`}>
                <button disabled={this.props.index == this.props.rule_count - 2} className="btn btn-black btn-icon btn-lg mb-1" type="button" data-toggle="tooltip" data-placement="top" title="Reorder Rule Down" onClick={this.onReorderDownClick} >
                 <FeatherIcon icon="chevron-down"/>
                </button>
              </div>
              <div className="mr-1">
                <button className="btn btn-blue btn-icon btn-lg mb-1" type="button" data-toggle="tooltip" data-placement="top" title="Edit rule" onClick={this.onEditClick} >
                 <FeatherIcon icon="edit"/>
                </button>
              </div>
              <div className={`mr-1 ${this.props.rule.default_rule ? 'invisible' : 'visible'}`}>
                <button className="btn btn-red btn-icon btn-lg mb-1" type="button" data-toggle="tooltip" data-placement="top" title="Delete rule" onClick={this.onDeleteClick} >
                 <FeatherIcon icon="delete"/>
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-3">
            <div className="mb-3 mt-5 action-control">
              <div className="form-tooltip">
                <span className={`mx-1 fw-bolder ${this.props.rule.default_rule ? '' : 'd-none'}`}>Default Rule <FeatherIcon icon="help-circle" className="mt-1"/></span>
                <span className="form-tooltiptext">This rule is active when no other rule applies to the current time period.</span>
              </div>
              <div className="form-tooltip">
                <span className={`mx-1 fw-bolder ${this.props.activeRuleId() == this.props.rule.id ? '' : 'd-none'}`}>Active Rule <FeatherIcon icon="help-circle" className="mt-1"/></span>
                <span className="form-tooltiptext">Given the current state of the rules, this rule would be active assuming all changes are saved.</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </React.Fragment>
    )

    var editing = (
      <React.Fragment>
      <div className={`rule ${this.props.activeRuleId() == this.props.rule.id ? 'active' : ''} ${this.props.rule.default_rule ? 'default-rule' : ''}`}>
        <form className={ `dynoform needs-validation ${this.state.validated ? 'was-validated' : ''}`}>
          <div className="row pt-3 pb-2">
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="dyno-range">
                <label>
                  <div className="form-tooltip">
                    <span className="fw-bolder">Dynos <FeatherIcon icon="help-circle" className="mt-1"/></span>
                    <span className="form-tooltiptext">What is the upper and lower range of dynos that auto scale for this rule?</span>
                  </div>
                  <span className="error" aria-live="polite"></span>
                </label>
                <input required className="form-control dyno-count dyno-lower-bound" type="number" min={this.props.type == "Worker" ? 0 : 1} max="99" step="1" value={this.props.rule.dyno_lower_bound}  data-field="dyno_lower_bound" onChange={this.onUpdateRuleChange}/><span> - </span>
                <input required className="form-control dyno-count dyno-upper-bound" type="number" min={this.props.type == "Worker" ? 0 : 1} max="99" step="1" value={this.props.rule.dyno_upper_bound} data-field="dyno_upper_bound" onChange={this.onUpdateRuleChange}/>
              </div>
            </div>
            <div className={`col-md-6 col-lg-2 mb-3 ${this.props.rule.default_rule ? 'd-none' : ''}`}>
              <div className="mb-3">
                <label>
                  <div className="form-tooltip">
                    <span className="fw-bolder">Day of Week <FeatherIcon icon="help-circle" className="mt-1"/></span>
                    <span className="form-tooltiptext">What day of the week does this rule operate on?</span>
                  </div>
                  <select required={!this.props.rule.default_rule} className="form-control" value={this.props.rule.dow} data-field="dow" onChange={this.onUpdateRuleChange}>
                    { this.props.options.dow.map((dow, index) => (
                      <option value={dow[0]} key={index}>{dow[0]}</option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
            <div className={`col-md-6 col-lg-2 mb-3 ${this.props.rule.default_rule ? 'd-none' : ''}`}>
              <div className="mb-3">
                <label>
                  <div className="form-tooltip">
                    <span className="fw-bolder">Start At <FeatherIcon icon="help-circle" className="mt-1"/></span>
                    <span className="form-tooltiptext">{ `What hour should this rule start on in ${Intl.DateTimeFormat().resolvedOptions().timeZone} timezone?` }</span>
                  </div>
                  <input required={!this.props.rule.default_rule} className="form-control time_start_at" type="time" value={this.props.rule.time_start_at} data-field="time_start_at" step="1" onChange={this.onUpdateRuleChange}/>
                </label>
              </div>
          </div>
          <div className={`col-md-6 col-lg-2 mb-3 ${this.props.rule.default_rule ? 'd-none' : ''}`}>
            <div className="mb-3">
              <label>
                <div className="form-tooltip">
                  <span className="fw-bolder">End At <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">{ `What hour should this rule end on in ${Intl.DateTimeFormat().resolvedOptions().timeZone} timezone?` }</span>
                </div>
                <input required={!this.props.rule.default_rule} className="form-control time_end_at" type="time" value={this.props.rule.time_end_at} data-field="time_end_at" step="1" onChange={this.onUpdateRuleChange}/>
              </label>
            </div>
          </div>
          <div className={`d-none d-md-none d-lg-block mb-3 ${this.props.rule.default_rule ? 'col-lg-9' : 'col-lg-3'}`}>
            <div className="mb-3 mt-3 action-control">
              <div className="mr-1">
                <button className="btn btn-green btn-icon btn-lg save-rule" type="button" data-toggle="tooltip" data-placement="top" title="Save rule change" onClick={this.onSaveClick} >
                 <FeatherIcon icon="save"/>
                </button>
              </div>
              <div className="mr-1">
                <button className="btn btn-black btn-icon btn-lg cancel-rule" type="button" data-toggle="tooltip" data-placement="top" title="Cancel rule change" onClick={this.onCancelClick}>
                  <FeatherIcon icon="x"/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={`row ${this.props.type == "Worker" ? '' : 'd-none'}`}>
          <div className="col-md-6 col-lg-6 mb-3">
            <div className="mb-3">
              <label>
                <div className="form-tooltip">
                  <span className="fw-bolder">Queues <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">{ `What queues are included in this rule when determining to auto scale?` }</span>
                </div>
              </label>
              <Select defaultValue={this.formatSelectedQueues} styles={customStyles} isMulti name="queues" options={this.props.options.queues} data-field="queues" className="queue-multi-select" classNamePrefix="select" onChange={this.onUpdateRuleQueueChange}/>
            </div>
          </div>
        </div>
        <div className="row">
            <div className="col-md-12 col-lg-10 mb-3">
              <div className="mb-3 threshold-config upscale-threshold-config">
              <label>
                <div className="form-tooltip">
                  <span className="fw-bolder">Upscale Configuration <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">Configuration information for upscaling</span>
                </div>
              </label>
              <div className="mb-1">When request queuing hits </div>
              <input required className="form-control threhold mb-1" type="number"  min="0" step="1" value={this.props.rule.upscale_threshold} data-field="upscale_threshold" onChange={this.onUpdateRuleChange}/><span> ms, upscale by </span>
              <input required className="form-control increment mb-1" type="number" min="0" step="1"  value={this.props.rule.upscale_increment} data-field="upscale_increment" onChange={this.onUpdateRuleChange}/><span> dyno(s) with a </span>
              <input required className="form-control ellapsed mb-1 upscale_ellapsed" type="number"  min="30" step="1" value={this.props.rule.upscale_ellapsed} data-field="upscale_ellapsed" onChange={this.onUpdateRuleChange}/><span> s delay between upscales</span>
            </div>
          </div>
        </div>
        <div className="row">
            <div className="col-md-12 col-lg-9 mb-3">
              <div className="mb-3 threshold-config downscale-threshold-config">
              <label>
                <div className="form-tooltip">
                  <span className="fw-bolder">Downscale Configuration <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">Configuration information for downscaling</span>
                </div>
              </label>
              <div className="mb-1">When request queuing hits </div>
              <input required className="form-control threhold mb-1" type="number"  min="0" step="1" value={this.props.rule.downscale_threshold} data-field="downscale_threshold" onChange={this.onUpdateRuleChange}/><span> ms, downscale by </span>
              <input required className="form-control increment mb-1" type="number" min="0" step="1" value={this.props.rule.downscale_increment} data-field="downscale_increment" onChange={this.onUpdateRuleChange}/><span> dyno(s) with a </span>
              <input required className="form-control ellapsed mb-1 downscale_ellapsed" type="number"  min="30" step="1" value={this.props.rule.downscale_ellapsed} data-field="downscale_ellapsed" onChange={this.onUpdateRuleChange}/><span> s delay between downscales</span>
              </div>
            </div>
            <div className="d-lg-none d-md-block col-lg-3 mb-3">
            <div className="mb-3 mt-3 action-control">
              <div className="mr-1">
                <button className="btn btn-green btn-icon btn-lg" type="button" data-toggle="tooltip" data-placement="top" title="Save rule change" onClick={this.onSaveClick} >
                 <FeatherIcon icon="save"/>
                </button>
              </div>
              <div className="mr-1">
                <button className="btn btn-black btn-icon btn-lg" type="button" data-toggle="tooltip" data-placement="top" title="Cancel rule change" onClick={this.onCancelClick}>
                  <FeatherIcon icon="x"/>
                </button>
              </div>
            </div>
          </div>
            <div className="col-md-12 col-lg-3">
              <div className="mb-3 mt-5 action-control">
                <div className="form-tooltip">
                  <span className={`mx-1 fw-bolder ${this.props.rule.default_rule ? '' : 'd-none'}`}>Default Rule <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">This rule is active when no other rule applies to the current time period.</span>
                </div>
                <div className="form-tooltip">
                  <span className={`mx-1 fw-bolder ${this.props.activeRuleId() == this.props.rule.id ? '' : 'd-none'}`}>Active Rule <FeatherIcon icon="help-circle" className="mt-1"/></span>
                  <span className="form-tooltiptext">Given the current state of the rules, this rule would be active assuming all changes are saved.</span>
                </div>
              </div> 
            </div>
        </div>
      </form>
      </div>
      </React.Fragment>
    );
    if (this.state.editing){
      return editing;
    }
    else {
      return not_editing;
    }
  }
}

Rule.defaultProps = {
  rule: { default_rule: false, upscale_threshold: 20000, upscale_increment: 2, upscale_ellapsed: 60, downscale_threshold: 1000, downscale_increment: 1, downscale_ellapsed: 120, editing: false, time_start_at: "", time_end_at: "", dow: "everyday", dyno_lower_bound: "", dyno_upper_bound: "", timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, queues: []},
  options: { dow: [] },
  deleteRule: null,
  onCreateRule: null,
  saveRule: null
}


Rule.propTypes = {
  rule: PropTypes.object,
  index: PropTypes.number,
  rule_count: PropTypes.number,
  options: PropTypes.object,
  rollbackToLastUndoMark: PropTypes.func,
  setRuleUndoMark: PropTypes.func,
  deleteRule: PropTypes.func,
  onCreateRule: PropTypes.func,
  saveRule: PropTypes.func,
  editingRule: PropTypes.func,
  updateRule: PropTypes.func,
  reorderUp: PropTypes.func,
  reorderDown: PropTypes.func,
  activeRuleId: PropTypes.func,
  prev_rule: PropTypes.object,
  type: PropTypes.string
};

export default Rule
